import React, { useEffect, useRef, useState } from 'react';
import Button from '../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { passport, courseList, state } from '../utils/constant';
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import localizedFormat from "dayjs/plugin/localizedFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import utc from "dayjs/plugin/utc";
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import useFormValidation from '../hooks/useFormValidation';
import { registrationFormValidationSchema } from '../utils/formValidation';
import { errorToast } from '../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { DatePicker, Divider, Select, Space } from 'antd';
import { getStudentForRegistration, register } from '../services/studentApi';
import { getAjahn, getCourses } from '../services/settings';
import AutoShrinkText from '../utils/AutoShrinkText';
import CustomModal from '../components/CustomModal';
import { IoEye, IoEyeOff } from 'react-icons/io5';

const base_url = process.env.REACT_APP_BASE_URL

const CourseRegistration = () => {

    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [courseData, setCourseData] = useState(null);
    const [ajahnsList, setAjahnsList] = useState([]);
    const languageSelected = localStorage.getItem('i18nextLng');
    const [isPledge, setIsPledge] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const openDropdownsRef = useRef(0); // Track the number of open dropdowns
    const [formSection, setFormSection] = useState(1);
    const [formData, setFormData] = useState({});
    const [courseListData, setCourseListData] = useState({});
    const [oriCourseListData, setOriCourseListData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(registrationFormValidationSchema(t));
    const navigate = useNavigate();
    const [formPercentage, setFormPercentage] = useState("14%");
    const [confirmEmailError, setConfirmEmailError] = useState(null);
    const [previews, setPreviews] = useState({});

    const navigateWithConfirm = (to) => {
        if (isPledge) {
            const ok = window.confirm(
                "You have unsaved changes. Do you really want to leave?"
            );
            if (!ok) return;
        }
        navigate(to);
    };

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isPledge) {
                e.preventDefault();
                e.returnValue = ""; // required for Chrome
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isPledge]);

    // modal
    const [isModalOpen, setIsModalOpen] = useState(true);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const handleToggle = () => {
        setShowPassword(!showPassword);
    }
    const [showPassword, setShowPassword] = useState(true);

    dayjs.extend(localizedFormat);
    dayjs.extend(advancedFormat);
    dayjs.extend(utc);
    const pageThreeValdationFields = [
        "participation_type",
        "declaration",
        "is_five_precepts",
        "is_five_precepts",
        "watched_luangpu_video",
        "practice_frequency",
        // "preretreat_consent",
        // "accommodation_consent",
    ];
    const pageFiveValdationFields = [
        "cname",
        "ename",
        "identity",
        "gender",
        "birthdate",
        "passport_region",
        "residence_region",
        "email",
        "mobile",
        "preferred_social_media",
    ];

    const pageSixValdationFields = [
        "retreat_language",
        // "interview_language",
        // "pre_retreat_language"
    ];

    const generateValidationFields = (validationFields) => {

        if (formSection === 3) {
            formData.is_mental_disease === "1" && validationFields.push("mental_disease_details");
            formData.is_learning_with_others === "1" && validationFields.push("other_ajahn");
            formData.watched_luangpu_video === "0" && validationFields.push("commit_watch_video");
            formData.participation_type === 'In-person' && validationFields.push(
                "participation_consent",
                "cooperation_consent",
                "photo_consent",
                "is_learning_with_others",
                "is_mental_disease",
            );
            formData.participation_type === 'Online' && validationFields.push(
                "attendance_consent",
            );
        }
        if (formSection === 5) {
            formData.participation_type === 'In-person' && validationFields.push(
                "personal_photo",
            );
            formData.identity === "lay" && validationFields.push("profession");
            formData.identity === "sangha" && validationFields.push("sangha_cname", "sangha_ename");
            if (formData.preferred_social_media === "Wechat") {
                validationFields.push("wechat_id", "wechat_name", "wechat_image");
            } else if (formData.preferred_social_media === "Whatsapp") {
                validationFields.push("whatsapp");
            } else if (formData.preferred_social_media === "Line") {
                validationFields.push("line_id", "line_image");
            }
            if (formData.residence_region === "China") {
                validationFields.push("province");
            };
            if (formData.residence_region === "Malaysia") {
                validationFields.push("state");
            };
            if (formData.residence_region === "Other") {
                validationFields.push("other_residence_region");
            };
            if (formData.passport_region === "Other") {
                validationFields.push("other_passport_region");
            };
        }

        if (formSection === 6) {
            formData.participation_type === 'In-person' && validationFields.push(
                "interview_language",
            );
        }
        return validationFields;
    };

    const handleDateChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            "birthdate": e,
        }));
    };

    useEffect(() => {
        if (formData.email !== formData.confirmEmail) {
            setConfirmEmailError(t("FormValid.confirmEmailNotTally"));
        } else {
            setConfirmEmailError(null);
        }
    }, [formData.email, formData.confirmEmail]);

    const navigateFormSection = (forward) => {
        let validationFields = [];
        if (forward) {
            switch (formSection) {
                case 3:
                    validationFields = generateValidationFields(pageThreeValdationFields);
                    break;
                case 5:
                    validationFields = generateValidationFields(pageFiveValdationFields);
                    break;
                case 6:
                    validationFields = generateValidationFields(pageSixValdationFields);
                    break;
            }
        };
        if (validateAllFields(formData, validationFields) && !confirmEmailError) {
            const section = forward ? formSection + 1 : formSection - 1;
            setFormSection(section);
            const percentage = (section / 7) * 100;
            const percentageString = percentage + "%";
            setFormPercentage(percentageString);
        } else {
            toast.error(t("general.ValidateFailed"));
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [formSection])

    // experience

    useEffect(() => {
        if (isDropdownOpen) {
            document.body.style.overflow = 'hidden'; // Disable body scroll
        } else {
            document.body.style.overflow = 'auto';  // Re-enable body scroll
        }
    }, [isDropdownOpen]);

    const getAllCourse = async () => {
        try {
            setIsLoading(true);
            const res = await getCourses();


            if (res) {
                const now = new Date();
                const filteredRes = res.filter(item => {
                    const startDate = new Date(item.start_datetime);
                    return startDate < now;
                });
                const grouped = filteredRes.reduce((acc, item) => {
                    var category = item.course_category;

                    if (typeof category === 'string' && category.includes('online')) {
                        category = 'online_course';
                    }

                    if (!acc[category]) {
                        acc[category] = [];
                    }

                    const newItem = {
                        id: item.id,
                        course_cname: item.course_cname,
                        course_ename: item.course_ename,
                        start_datetime: item.start_datetime,
                        end_datetime: item.end_datetime,
                        value: item.id,
                        label: languageSelected === "en" ? item.course_ename : item.course_cname,
                        participated: 0
                    };

                    acc[category].push(newItem);

                    return acc;
                }, {});
                setCourseListData(grouped);
                setOriCourseListData(grouped);
                const activeCourse = res.find(e => e.status === '1');
                setCourseData(activeCourse);

                const ajahnRes = await getAjahn(activeCourse.id);
                if (ajahnRes.length > 0) {
                    setAjahnsList(ajahnRes);
                }
            }
        } catch (error) {
            console.log(error);
            toast.error(t('general.ActionFailed'));
        } finally {
            setIsLoading(false);
        }
    }

    const fetchOldData = async () => {
        setIsSubmitting(true);
        try {
            if (typeof formData?.student_no !== "string" || formData.student_no.trim() === "") {
                toast.error(t("FormValid.studentNo"));
                setIsSubmitting(false);
            } else if (typeof formData?.password !== "string" || formData.password.trim() === "") {
                toast.error(t("FormValid.RequiredPword"));
                setIsSubmitting(false);
            } else {
                const response = await getStudentForRegistration(formData);
                const data = response.data.data;
                if (data === 404) {
                    toast.error(t("login.invalidUsername"));
                } else if (data === 401) {
                    toast.error(t("login.invalidCredentials"));
                } else {
                    toast.success(t("registration.successLink"));
                    toggleModal();
                    setFormData(prev => ({
                        ...prev,
                        ...data.user,
                        confirmEmail: data?.user?.email, // override the field you want
                    }));
                    courseList(t).map((i) => {
                        handleExperienceChange(data.experience, i.category);
                    });

                }
            }
        } catch (error) {
            errorToast(error, t("general.ActionFailed"), t);
        } finally {
            setIsSubmitting(false);
        }
    };
    const getSelectedCourses = (courseData) => {
        return (courseData ?? [])
            .filter(item => item.participated === "1")
            .map(item => ({
                value: item.value,
                label: languageSelected === "en"
                    ? item.course_ename
                    : item.course_cname
            }));
    };

    useEffect(() => {
        getAllCourse();
    }, []);

    const handleExperienceChange = (selectedIds, category) => {
        setCourseListData((prevState) => ({
            ...prevState,
            [category]: oriCourseListData[category].map(item => ({
                ...item,
                participated: selectedIds.includes(item.value) ? "1" : "0"
            }))
        }));
    }

    const handleDropdownVisibleChange = (open) => {
        // Update the ref count
        if (open) {
            openDropdownsRef.current += 1; // Increment when a dropdown opens
        } else {
            openDropdownsRef.current -= 1; // Decrement when a dropdown closes
        }

        // Update the state based on the ref count
        setIsDropdownOpen(openDropdownsRef.current > 0);
    };

    const handleInputChange = (e) => {
        const { id, value, name, type } = e.target;
        if (type === "radio") {
            setFormData((prevState) => ({
                ...prevState,
                [name]: id,
            }));
            validateField(name, id);
        } else if (id === "preferred_social_media") {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
                "wechat_id": "",
                "wechat_name": "",
                "wechat_image": "",
                "whatsapp": "",
                "line_id": "",
                "line_image": "",
            }));
            setFileError("");
            setPreviews((prev) => ({
                ...prev,
                ['wechat_image']: null,
                ['line_image']: null,
            }));
            validateField(id, value);
        } else if (id === "participation_type") {
            if (value === "Online") {
                setFormData((prevState) => ({
                    ...prevState,
                    [id]: value,
                    "participation_consent": "",
                    "cooperation_consent": "",
                    "photo_consent": "",
                    "is_learning_with_others": "",
                    "is_mental_disease": "",
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [id]: value,
                }));
            }
            validateField(id, value);
        } else if (id == 'mobile' || id == 'whatsapp') {
            if (value !== '') {
                if (/^[1-9]\d*$/.test(value)) {
                    setFormData((prevState) => ({
                        ...prevState,
                        [id]: value,
                    }));
                }
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [id]: value,
                }));
            }
            validateField(id, value);
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
        }
    };

    const [fileError, setFileError] = useState(null);
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    const handleFileChange = (event) => {
        const { id } = event.target;
        const selectedFile = event.target.files[0];
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "image/jpg",
            "image/heic"
        ];
        if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
            setFileError((prevState) => ({
                ...prevState,
                [id]: t("FormValid.FileExtensionAllow"),
            }));
            event.target.value = ""; // Clear the file input
            setPreviews((prev) => ({ ...prev, [id]: null }));
            return;
        } else if (selectedFile && selectedFile.size > maxSize) {
            setFileError((prevState) => ({
                ...prevState,
                [id]: t("FormValid.smallerFile10MB"),
            }));
            event.target.value = ""; // Clear the file input
            setPreviews((prev) => ({ ...prev, [id]: null }));
            return;
        }

        setFileError((prevState) => ({
            ...prevState,
            [id]: null,
        }));

        setFormData((prevState) => ({
            ...prevState,
            [id]: selectedFile,
        }));

        // set previews
        if (selectedFile && selectedFile.type.startsWith("image/")) {
            const previewUrl = URL.createObjectURL(selectedFile);
            setPreviews((prev) => ({
                ...prev,
                [id]: previewUrl,
            }));
        } else {
            // If PDF or non-image → no preview
            setPreviews((prev) => ({
                ...prev,
                [id]: null,
            }));
        }


        validateField(id, selectedFile);
    };

    const setNullFormToEmpty = (nullFormData) => {
        for (const [key, value] of Object.entries(nullFormData)) {
            if (value === null || value === undefined) {
                nullFormData[key] = ''; // Replace with an empty string
            }
        }
        return nullFormData;
    };

    const includeKeys = (keysToRemove) => {
        const updated = Object.fromEntries(
            Object.entries(formData).filter(([key]) => keysToRemove.includes(key))
        );
        return updated;
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            let initialValidationFields = [...pageThreeValdationFields, ...pageFiveValdationFields, ...pageSixValdationFields];
            let validationFields = generateValidationFields(initialValidationFields);
            let updatedFormData = includeKeys(validationFields);
            let transformedFormData = setNullFormToEmpty(updatedFormData);

            if (validateAllFields(transformedFormData, validationFields)) {
                // Step 4: Submit form data
                const combinedFormData = {
                    ...formData,
                    courseListData: JSON.stringify(courseListData),
                    fk_course_id: courseData.id,
                    lang: languageSelected === 'en' ? 'en' : 'cn',
                    birthdate: dayjs(formData.birthdate).format("YYYY-MM-DD"),
                };
                const response = await register(combinedFormData);
                if (response) {
                    toast.success(t("registration.successTitle"));
                    navigate(`${base_url}/course_registration_success`);
                }
            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };


    return (
        <>
            {
                isLoading && (!courseData || ajahnsList.length === 0) ?
                    <div className='m-5 d-flex justify-content-center'>
                        <AiOutlineLoading className='spin' />
                    </div>
                    :
                    !courseData && ajahnsList.length === 0 && !isLoading ?
                        <div className='form-wrapper d-flex flex-column'>
                            <h3 className='mt-5 d-flex justify-content-center'>{t("login.notOpen")}</h3>
                        </div>
                        :
                        <>
                            <div className='info-container'>
                                <h3 className='mb-2'>{localStorage.getItem("i18nextLng") === "en" ? courseData?.course_ename : courseData?.course_cname}  {t("registration.title")}</h3>
                                <p style={{ fontSize: '14px' }}>{t("registration.warning")}</p>
                                <p style={{ fontSize: '14px' }}>{t("registration.reminder")}</p>
                            </div>
                            <div className='form-wrapper'>
                                <h4 className='d-flex mt-3 justify-content-left'>{t("general.Page")} {formSection} {t("general.OF7")}</h4>
                                <div className="progress mb-5">
                                    <div className="progress-bar bg-success" role="progressbar" style={{ "width": formPercentage }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <form>
                                    <div className='form-section-1' hidden={formSection !== 1}>
                                        <CustomModal
                                            hideModal={toggleModal}
                                            open={isModalOpen}
                                            performAction={() => fetchOldData()}
                                            title={t("registration.modalTitle")}
                                            confirmLoading={isSubmitting}
                                            children={
                                                <p>
                                                    {t("registration.modalDescription")}
                                                    <div className="input-group d-flex justify-content-center mt-2">
                                                        <input
                                                            type="text"
                                                            value={formData?.student_no || ""}
                                                            className="form-control"
                                                            id="student_no"
                                                            placeholder={t("login.3rdStudentNo")}
                                                            onChange={handleInputChange}
                                                            name="student_no"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="password-input mt-3">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            value={formData?.password || ""} className="form-control"
                                                            id="password"
                                                            placeholder={t("login.password")}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <span className="position-absolute eye-icon" onClick={handleToggle}>
                                                            {showPassword ?
                                                                <IoEye className='absolute' />
                                                                :
                                                                <IoEyeOff className='absolute' />
                                                            }
                                                        </span>
                                                    </div>
                                                </p>
                                            }
                                        />
                                        <p>
                                            ☘️<strong>{t("registration.courseDetail")}</strong>
                                            <br /><Link to="https://www.shineling.org/retreat" target="_blank" rel="noopener noreferrer">www.shineling.org/retreat</Link>
                                        </p>
                                        <br />
                                        <p>
                                            ☘️<strong>{t("registration.ajahnTeam")}</strong>
                                        </p>
                                        <strong>{t("registration.ajahnTeamAttend")}</strong>
                                        <br />
                                        <ol>
                                            {
                                                ajahnsList
                                                    .filter(e => e.mode === "In-person")
                                                    .map((i, index) => (
                                                        <li key={index}>{localStorage.getItem("i18nextLng") === "en" ? i.ajahn_ename : i.ajahn_cname}</li>
                                                    ))
                                            }
                                        </ol>
                                        <strong>{t("registration.ajahnTeamOnline")}</strong>
                                        <br />
                                        <ol>
                                            {
                                                ajahnsList
                                                    .filter(e => e.mode === "Online")
                                                    .map((i, index) => (
                                                        <li key={index}>{localStorage.getItem("i18nextLng") === "en" ? i.ajahn_ename : i.ajahn_cname}</li>
                                                    ))
                                            }
                                        </ol>
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.courseDate")}</strong>
                                            <br />{t("registration.courseStartDate")}
                                            {
                                                localStorage.getItem("i18nextLng") === "en" ?
                                                    dayjs.utc(courseData?.start_datetime).format("D MMMM YYYY (dddd) h:mm A")
                                                    :
                                                    dayjs.utc(courseData?.start_datetime)
                                                        .locale("zh-cn")
                                                        .format("YYYY年M月D日 dddd A h:mm")
                                            }
                                            <br />{t("registration.courseEndDate")}
                                            {
                                                localStorage.getItem("i18nextLng") === "en" ?
                                                    dayjs.utc(courseData?.end_datetime).format("D MMMM YYYY (dddd) h:mm A")
                                                    :
                                                    dayjs.utc(courseData?.end_datetime)
                                                        .locale("zh-cn")
                                                        .format("YYYY年M月D日 dddd A h:mm")
                                            }
                                        </p>
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.courseLanguage")}</strong>
                                            <Trans html="br:<br/>">
                                                {t("registration.courseLanguageDescription")}
                                            </Trans>
                                        </p>
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.courseMethod")}</strong>
                                            <Trans html="br:<br/>">
                                                {t("registration.courseMethodDesription")}
                                            </Trans>
                                            <span style={{ "color": "#ff0000" }}>{t("registration.courseMethodDesription2")}</span>
                                        </p>
                                        <br />
                                        {/* <p>
                                            ☘️ <strong>{t("registration.qualificationQuota")}</strong>
                                            <Trans html="br:<br/>">
                                                {t("registration.qualificationQuotaDescription")}
                                            </Trans>
                                        </p>
                                        <br /> */}
                                        <p>
                                            ☘️ <strong>{t("registration.courseVenue")}</strong>
                                            <br />{localStorage.getItem("i18nextLng") === 'en' ? courseData?.venue_ename : courseData?.venue_cname}
                                            <br />
                                            <Trans html="br:<br/>">
                                                {t("registration.courseVenueDescription")}
                                            </Trans>
                                        </p>
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.accomodation")}</strong>
                                            <Trans html="br:<br/>">
                                                {t("registration.accomodationDescription")}
                                            </Trans>
                                        </p>
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.organizer")}</strong>
                                            <Trans html="br:<br/>">
                                                {t("registration.organizerDescription")}
                                            </Trans>
                                        </p>
                                        <br />
                                        <div>
                                            <p>
                                                <strong>{t("general.contact_Info")}</strong>
                                                <Trans key="general" html="br:<br/>">
                                                    {t("general.infoContent")}
                                                    <a href="mailto:retreat@shineling.org">{t("general.retreatEmail")}</a>
                                                </Trans>
                                                {/* <br />
                                                <Link to="https://www.shineling.org:3004" target="_blank" rel="noopener noreferrer">
                                                    {t("general.retreatChatbot")}
                                                </Link> */}
                                                <br />{t("general.retreatWhatsapp")}+6018-919 9096
                                                <br />{t("general.retreatWechat")}godhamma
                                            </p>
                                            <p>
                                                -----------------------------
                                                <Trans key="general" html="br/:<br />">
                                                    <br />{t("general.snl")}
                                                </Trans>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='form-section-2' hidden={formSection !== 2}>
                                        <h2 className='mb-4'>{t("registration.registerTerms")}</h2>
                                        <p>
                                            ☘️ <strong>{t("registration.inPersonRegisterTerms")}</strong>
                                        </p>
                                        <p>
                                            <Trans html="br/:<br />">
                                                {t("registration.inPersonTermsDescription")}
                                            </Trans>
                                        </p>

                                        {/* <p>
                                        ⛳️ <strong> {t("registration.oldStudent")}</strong>
                                    </p>
                                    <p>
                                        <Trans html="br/:<br />">
                                            {t("registration.oldStudentDescription")}
                                        </Trans>
                                    </p>
                                    <br />
                                    <p>
                                        ⛳️ <strong> {t("registration.newStudent")}</strong>
                                    </p>
                                    <p>
                                        {t("registration.newStudentDescription")}
                                        <br />{t("registration.newStudentDescription2")}
                                        <br /><span style={{ "color": "#ff0000" }}>{t("registration.newStudentDescription3")}</span>
                                    </p>
                                    <br />
                                    <p>
                                        ⛳️ <strong> {t("registration.studentTerms")}</strong>
                                    </p>
                                    <p>
                                        <Trans html="br/:<br />">
                                            {t("registration.studentTermsDescription")}
                                        </Trans>
                                    </p> */}
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.onlineStudentTerms")}</strong>
                                        </p>
                                        <p>
                                            <Trans html="br/:<br />">
                                                {t("registration.onlineStudentTermsDescription")}
                                            </Trans>
                                        </p>
                                        <br />
                                        <p>
                                            ☘️ <strong>{t("registration.registerImportant")}</strong>
                                        </p>
                                        <p>
                                            {t("registration.registerImportant1")}
                                            <span style={{ "color": "#ff0000" }}>{t("registration.registerImportant1_2")}</span>
                                            {t("registration.registerImportant1_3")}
                                            &nbsp;
                                            <Link to={`${base_url}/search_eligibility`} target="_blank" rel="noopener noreferrer">
                                                https://www.shineling.org/retreat-my/search_eligibility
                                            </Link>
                                        </p>
                                        <p>{t("registration.registerImportant3")}</p>
                                        <p><span style={{ "color": "#ff0000" }}>{t("registration.registerImportant4")}</span>{t("registration.registerImportant5")}</p>
                                        <p>{t("registration.registerImportant6")}<strong>{t("registration.registerImportant7")}</strong></p>
                                        <p>{t("registration.registerImportant8")}</p>
                                        <p>{t("registration.registerImportant9")}</p>
                                        <p>{t("registration.registerImportant10")}</p>
                                        <p>{t("registration.registerImportant11")}</p>

                                        <div className="form-item my-5">
                                            <label>{t("registration.pledge")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className="d-flex gap-2">
                                                <input type="checkbox" className="form-check-input p-2" onChange={(e) => setIsPledge(e.target.checked === true)} required />
                                                <p className='m-0'>{t("registration.pledgeDetails")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-section-3' hidden={formSection !== 3}>
                                        <h3>{t("registration.declarationTitle")}</h3>
                                        <div className="form-item">
                                            <label for='participation_type'>{t("registration.courseMethodLabel")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <select className="form-select" id='participation_type' onChange={handleInputChange}>
                                                <option value="">{t("registration.courseMethodLabel")}</option>
                                                <option value="In-person" disabled={courseData?.is_open_in_person === '0'}>
                                                    {courseData?.is_open_in_person === '1' ? t("registration.inPerson") : t("registration.inPersonFull")}
                                                </option>
                                                <option value="Online" disabled={courseData?.is_open_online === '0'}>
                                                    {courseData?.is_open_online === '1' ? t("registration.online") : t("registration.onlineFull")}
                                                </option>
                                            </select>
                                            {/* <div className="form-info">
                                            <p className='m-0'>{t("registration.courseMethodFormInfo")}</p>
                                        </div> */}
                                        </div>
                                        {errors.participation_type && <span className="error">{errors.participation_type}</span>}
                                        <div className="form-item">
                                            <label>{t("registration.declarationLabel")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="declaration" id="1" onChange={handleInputChange} checked={formData?.declaration === '1'} />
                                                <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                            </div>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="declaration" id="0" onChange={handleInputChange} checked={formData?.declaration === '0'} />
                                                <p className='radioLabel mb-0'>{t("general.no")}</p>
                                            </div>
                                        </div>
                                        {errors.declaration && <span className="error">{errors.declaration}</span>}
                                        <div className="form-item">
                                            <label>{t("registration.watchSessionsLabel")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="watched_luangpu_video" id="1" onChange={handleInputChange} checked={formData?.watched_luangpu_video === '1'} />
                                                <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                            </div>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="watched_luangpu_video" id="0" onChange={handleInputChange} checked={formData?.watched_luangpu_video === '0'} />
                                                <p className='radioLabel mb-0'>{t("general.no")}</p>
                                            </div>
                                        </div>
                                        {errors.watched_luangpu_video && <span className="error">{errors.watched_luangpu_video}</span>}
                                        {
                                            formData?.watched_luangpu_video === "0" &&
                                            <>
                                                <div className="form-item">
                                                    <label>{t("registration.commitWatchSessionsLabel")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <div className='radio'>
                                                        <input className="form-check-input" type="radio" name="commit_watch_video" id="1" onChange={handleInputChange} checked={formData?.commit_watch_video === '1'} />
                                                        <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                                    </div>
                                                    <div className='radio'>
                                                        <input className="form-check-input" type="radio" name="commit_watch_video" id="0" onChange={handleInputChange} checked={formData?.commit_watch_video === '0'} />
                                                        <p className='radioLabel mb-0'>{t("general.no")}</p>
                                                    </div>
                                                </div>
                                                <div className='form-info'>
                                                    {t("registration.watchSessionsSource")}
                                                </div>
                                            </>
                                        }
                                        {errors.commit_watch_video && <span className="error">{errors.commit_watch_video}</span>}
                                        <div className="form-item">
                                            <label>{t("registration.fivePreceptsLabel")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="is_five_precepts" id="1" onChange={handleInputChange} checked={formData?.is_five_precepts === '1'} />
                                                <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                            </div>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="is_five_precepts" id="0" onChange={handleInputChange} checked={formData?.is_five_precepts === '0'} />
                                                <p className='radioLabel mb-0'>{t("general.no")}</p>
                                            </div>
                                        </div>
                                        {errors.is_five_precepts && <span className="error">{errors.is_five_precepts}</span>}
                                        <div className="form-item">
                                            <label>{t("registration.practiceLabel")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <select className="form-select" id='practice_frequency' onChange={handleInputChange}>
                                                <option value="" hidden></option>
                                                <option value="daily">{t("registration.practiceEveryday")}</option>
                                                <option value="frequently">{t("registration.practiceAlways")}</option>
                                                <option value="ocassionally">{t("registration.practiceSometimes")}</option>
                                                <option value="never">{t("registration.practiceNever")}</option>
                                            </select>
                                        </div>
                                        {errors.practice_frequency && <span className="error">{errors.practice_frequency}</span>}

                                        {
                                            formData.participation_type && formData.participation_type === "In-person" ?
                                                <>
                                                    <div className="form-item">
                                                        <label>{t("registration.participationConsent")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="participation_consent" id="1" onChange={handleInputChange} checked={formData?.participation_consent === '1'} />
                                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                                        </div>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="participation_consent" id="0" onChange={handleInputChange} checked={formData?.participation_consent === '0'} />
                                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                                        </div>
                                                    </div>
                                                    {errors.participation_consent && <span className="error">{errors.participation_consent}</span>}
                                                    <div className="form-item">
                                                        <label>{t("registration.cooperationConsent")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="cooperation_consent" id="1" onChange={handleInputChange} checked={formData?.cooperation_consent === '1'} />
                                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                                        </div>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="cooperation_consent" id="0" onChange={handleInputChange} checked={formData?.cooperation_consent === '0'} />
                                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                                        </div>
                                                    </div>
                                                    {errors.cooperation_consent && <span className="error">{errors.cooperation_consent}</span>}
                                                    {/* <div className="form-item">
                                        <label>{t("registration.preretreatConsent")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="preretreat_consent" id="1" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                        </div>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="preretreat_consent" id="0" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                        </div>
                                    </div>
                                    {errors.preretreat_consent && <span className="error">{errors.preretreat_consent}</span>} */}
                                                    <div className="form-item">
                                                        <label>{t("registration.photoConsent")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="photo_consent" id="1" onChange={handleInputChange} checked={formData?.photo_consent === '1'} />
                                                            <p className='radioLabel mb-0'>{t("registration.willing")}</p>
                                                        </div>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="photo_consent" id="0" onChange={handleInputChange} checked={formData?.photo_consent === '0'} />
                                                            <p className='radioLabel mb-0'>{t("registration.notWilling")}</p>
                                                        </div>
                                                    </div>
                                                    {errors.photo_consent && <span className="error">{errors.photo_consent}</span>}
                                                    {/* <div className="form-item">
                                        <label>{t("registration.accommodationConsent")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="accommodation_consent" id="1" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                        </div>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="accommodation_consent" id="0" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                        </div>
                                    </div>
                                    {errors.accommodation_consent && <span className="error">{errors.accommodation_consent}</span>} */}
                                                    <div className="form-item">
                                                        <label>{t("registration.learningWithOthers")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="is_learning_with_others" id="1" onChange={handleInputChange} checked={formData?.is_learning_with_others === '1'} />
                                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                                        </div>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="is_learning_with_others" id="0" onChange={handleInputChange} checked={formData?.is_learning_with_others === '0'} />
                                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                                        </div>
                                                    </div>
                                                    {errors.is_learning_with_others && <span className="error">{errors.is_learning_with_others}</span>}
                                                    {
                                                        formData.is_learning_with_others === "1" &&
                                                        <>
                                                            <div className="form-item">
                                                                <label className="form-label">{t("registration.learningTeacher")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                                <input type="text" className="form-control" id="other_ajahn" value={formData.other_ajahn || ""} onChange={handleInputChange} />
                                                            </div>
                                                            {errors.other_ajahn && <span className="error">{errors.other_ajahn}</span>}
                                                        </>
                                                    }
                                                    <div className="form-item">
                                                        <label>{t("registration.isDisease")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="is_mental_disease" id="1" onChange={handleInputChange} checked={formData?.is_mental_disease === '1'} />
                                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                                        </div>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="is_mental_disease" id="0" onChange={handleInputChange} checked={formData?.is_mental_disease === '0'} />
                                                            <p className='radioLabel mb-0'>{t("general.noWithDescription")}</p>
                                                        </div>
                                                    </div>
                                                    {errors.is_mental_disease && <span className="error">{errors.is_mental_disease}</span>}
                                                    {
                                                        formData.is_mental_disease === "1" &&
                                                        <>
                                                            <div className="form-item">
                                                                <label className="form-label">{t("registration.diseaseDetail")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                                <input type="text" className="form-control" id="mental_disease_details" value={formData.mental_disease_details || ""} onChange={handleInputChange} />
                                                            </div>
                                                            {errors.mental_disease_details && <span className="error">{errors.mental_disease_details}</span>}
                                                        </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    <div className="form-item">
                                                        <label>{t("registration.attendanceConsent")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="attendance_consent" id="1" onChange={handleInputChange} checked={formData?.attendance_consent === '1'} />
                                                            <p className='radioLabel mb-0'>{t("registration.accept")}</p>
                                                        </div>
                                                        <div className='radio'>
                                                            <input className="form-check-input" type="radio" name="attendance_consent" id="0" onChange={handleInputChange} checked={formData?.attendance_consent === '0'} />
                                                            <p className='radioLabel mb-0'>{t("registration.notAccept")}</p>
                                                        </div>
                                                    </div>
                                                    {errors.attendance_consent && <span className="error">{errors.attendance_consent}</span>}
                                                </>
                                        }

                                    </div>
                                    <div className='form-section-4' hidden={formSection !== 4}>
                                        <h5 className='mt-3'>{t("registration.chooseCourseIntruction")}</h5>
                                        {
                                            courseList(t).map((i, index) => {
                                                return (
                                                    <>
                                                        <div className="form-item" key={index}>
                                                            <label>{i.label}</label>
                                                        </div>
                                                        <Select
                                                            // key={getSelectedCourses(courseListData[i.category])}
                                                            mode="multiple"
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            dropdownStyle={{ maxHeight: 300, overflowY: "auto" }}
                                                            size='large'
                                                            value={getSelectedCourses(courseListData[i.category])}
                                                            showSearch={false}
                                                            // onDropdownVisibleChange={handleDropdownVisibleChange}
                                                            placeholder={t("Experience.instruction")}
                                                            onChange={(e) => handleExperienceChange(e, i.category)}
                                                            options={courseListData[i.category]}
                                                            optionRender={(option) =>
                                                            (
                                                                <Space direction='vertical'>
                                                                    <AutoShrinkText maxFont={16} minFont={12}>
                                                                        <span style={{ color: "#e67300" }}>
                                                                            {languageSelected === "en" ? option.data.course_ename : option.data.course_cname}
                                                                        </span>
                                                                    </AutoShrinkText>
                                                                    <span style={{ color: "#575655" }}>
                                                                        {
                                                                            i.category !== "international_english_course" ?
                                                                                localStorage.getItem("i18nextLng") === "en" ?
                                                                                    dayjs.utc(option.data.start_datetime).format("D-")
                                                                                    +
                                                                                    dayjs.utc(option.data.end_datetime).format("D MMMM YYYY")
                                                                                    :
                                                                                    dayjs.utc(option.data.start_datetime)
                                                                                        .locale("zh-cn")
                                                                                        .format("YYYY年M月D日 - ")
                                                                                    +
                                                                                    dayjs.utc(option.data.end_datetime)
                                                                                        .locale("zh-cn")
                                                                                        .format("M月D日")
                                                                                :
                                                                                ""
                                                                        }
                                                                    </span>
                                                                    <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                                                </Space>
                                                            )
                                                            }
                                                        />
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className='form-section-5' hidden={formSection !== 5}>
                                        <h3>{t("registration.personalInfo")}</h3>
                                        <div className="form-item">
                                            <label className="form-label">{t("personal_info.cname")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input type="text" className="form-control" id="cname" placeholder="" onChange={handleInputChange} value={formData?.cname} />
                                        </div>
                                        {errors.cname && <span className="error">{errors.cname}</span>}
                                        <div className="form-item">
                                            <label className="form-label">{t("personal_info.ename")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input type="text" className="form-control" id="ename" placeholder="" onChange={handleInputChange} value={formData?.ename} />
                                        </div>
                                        {errors.ename && <span className="error">{errors.ename}</span>}
                                        <div className="form-item">
                                            <label>{t("personal_info.identity")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="identity" id="lay" checked={formData?.identity === "lay"} onChange={handleInputChange} />
                                                <p className='radioLabel mb-0'>{t("personal_info.lay")}</p>
                                            </div>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="identity" id="sangha" checked={formData?.identity === "sangha"} onChange={handleInputChange} />
                                                <p className='radioLabel mb-0'>{t("personal_info.sangha")}</p>
                                            </div>
                                        </div>
                                        {errors.identity && <span className="error">{errors.identity}</span>}
                                        {formData.identity === "sangha" &&
                                            <>
                                                <div className="form-item">
                                                    <label>{t("personal_info.sangha_cname")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="sangha_cname" value={formData.sangha_cname || ""} onChange={handleInputChange} />
                                                </div>
                                                {errors.sangha_cname && <span className="error">{errors.sangha_cname}</span>}
                                                <div className="form-item">
                                                    <label className="form-label">{t("personal_info.sangha_ename")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="sangha_ename" value={formData.sangha_ename || ""} onChange={handleInputChange} />
                                                </div>
                                                {errors.sangha_ename && <span className="error">{errors.sangha_ename}</span>}
                                            </>
                                        }
                                        {formData.identity === "lay" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("registration.profession")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="profession" value={formData.profession || ""} onChange={handleInputChange} />
                                                </div>
                                                {errors.profession && <span className="error">{errors.profession}</span>}
                                            </>
                                        }
                                        <div className="form-item">
                                            <label>{t("personal_info.gender")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="gender" id="Male" checked={formData?.gender === "Male"} onChange={handleInputChange} required />
                                                <p className='radioLabel mb-0'>{t("personal_info.male")}</p>
                                            </div>
                                            <div className='radio'>
                                                <input className="form-check-input" type="radio" name="gender" id="Female" checked={formData?.gender === "Female"} onChange={handleInputChange} required />
                                                <p className='radioLabel mb-0'>{t("personal_info.female")}</p>
                                            </div>
                                        </div>
                                        {errors.gender && <span className="error">{errors.gender}</span>}
                                        <div className="form-item">
                                            <label className="form-label">{t("personal_info.birthdate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <DatePicker
                                                placeholder={t("general.date")}
                                                value={formData.birthdate ? dayjs(formData.birthdate) : null}
                                                onChange={handleDateChange}
                                                inputReadOnly={true}
                                            />
                                        </div>
                                        {errors.birthdate && <span className="error">{errors.birthdate}</span>}
                                        <div className="form-item">
                                            <label for='passport_region'>{t("Passport.Region_pass")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <select className="form-select" id='passport_region'
                                                onChange={(e) => { handleInputChange(e) }}
                                                value={formData?.passport_region || ""}

                                            >
                                                <option value="" hidden></option>
                                                {
                                                    passport(t).map((i, index) => (
                                                        <option key={index} value={i.key}>{i.country}</option>
                                                    ))
                                                }
                                                <option value="Other">{t("Constant.other")}</option>
                                            </select>
                                        </div>
                                        {errors.passport_region && <span className="error">{errors.passport_region}</span>}
                                        {
                                            formData?.passport_region === "Other" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("Passport.otherPassportRegion")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="other_passport_region" onChange={handleInputChange} />
                                                </div>
                                                {errors.other_passport_region && <span className="error">{errors.other_passport_region}</span>}
                                            </>
                                        }
                                        <div className="form-item">
                                            <label for='residence_region'>{t("registration.residentialRegion")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <select className="form-select" id='residence_region'
                                                onChange={(e) => { handleInputChange(e) }}
                                                value={formData?.residence_region || ""}
                                            >
                                                <option value="" hidden></option>
                                                {
                                                    passport(t).map((i, index) => (
                                                        <option key={index} value={i.key}>{i.country}</option>
                                                    ))
                                                }
                                                <option value="Other">{t("Constant.other")}</option>
                                            </select>
                                        </div>
                                        {errors.residence_region && <span className="error">{errors.residence_region}</span>}
                                        {
                                            formData?.residence_region === "Other" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("registration.otherResidentialRegion")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="other_residence_region" onChange={handleInputChange} />
                                                </div>
                                                {errors.other_residence_region && <span className="error">{errors.other_residence_region}</span>}
                                            </>
                                        }
                                        {
                                            formData?.residence_region === "China" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("registration.province")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="province" value={formData.province || ""} required onChange={handleInputChange} />
                                                </div>
                                                {errors.province && <span className="error">{errors.province}</span>}
                                            </>
                                        }
                                        {
                                            formData?.residence_region === "Malaysia" &&
                                            <>
                                                <>
                                                    <div className="form-item">
                                                        <label for='residence_region'>{t("registration.state")}
                                                            <span style={{ "color": "#ff0000" }}>*</span></label>
                                                        <select className="form-select" id='state'
                                                            onChange={(e) => { handleInputChange(e) }}
                                                            value={formData?.state || ""}
                                                        >
                                                            <option value="" hidden></option>
                                                            {
                                                                state(t).map((i, index) => (
                                                                    <option key={index} value={i.key}>{i.state}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>
                                                    {errors.state && <span className="error">{errors.state}</span>}
                                                </>
                                            </>
                                        }
                                        <div className="form-item">
                                            <label className="form-label">{t("personal_info.email")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input type="text" className="form-control" id="email" placeholder="" onChange={handleInputChange} value={formData?.email || ""} />
                                        </div>
                                        {errors.email && <span className="error">{errors.email}</span>}
                                        <div className="form-item">
                                            <label className="form-label">{t("personal_info.confirmEmail")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input type="text" className="form-control" id="confirmEmail" placeholder="" onChange={handleInputChange} value={formData?.confirmEmail || ""} />
                                        </div>
                                        {confirmEmailError && <span className="error">{confirmEmailError}</span>}
                                        <div className="form-item">
                                            <label className="form-label">{t("personal_info.mobile")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                            <input type="text" className="form-control" id="mobile" placeholder="e.g. 60123456789" onChange={handleInputChange} value={formData.mobile || ""} required />
                                        </div>
                                        {errors.mobile && <span className="error">{errors.mobile}</span>}
                                        <div className="form-info">
                                            <p className='m-0'>{t("personal_info.mobile_msg")}<br />{t("personal_info.mobile_country")}</p>
                                        </div>
                                        <div className="form-item">
                                            <label for='preferred_social_media'>{t("registration.contactPreference")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <select className="form-select" id='preferred_social_media' onChange={handleInputChange} value={formData?.preferred_social_media || ""}>
                                                <option value="" hidden></option>
                                                <option value="Wechat">{t("registration.contactOption1")}</option>
                                                <option value="Whatsapp">{t("registration.contactOption2")}</option>
                                                <option value="Line">{t("registration.contactOption3")}</option>
                                            </select>
                                            <div className="form-info">
                                                <p className='m-0'>{t("registration.contactPreferenceFormInfo")}</p>
                                            </div>
                                        </div>
                                        {errors.preferred_social_media && <span className="error">{errors.preferred_social_media}</span>}
                                        {
                                            formData.preferred_social_media === "Whatsapp" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("personal_info.whatsapp")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="whatsapp" value={formData.whatsapp || ""} onChange={handleInputChange} required />
                                                </div>
                                                <div className="form-info">
                                                    <p className='p-0 m-0'>{t("personal_info.whatsapp_msg")}<br />{t("personal_info.whatsapp_country")}</p>
                                                </div>
                                                {errors.whatsapp && <span className="error">{errors.whatsapp}</span>}
                                            </>
                                        }
                                        {
                                            formData.preferred_social_media === "Wechat" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("personal_info.wechatid")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="wechat_id" value={formData.wechat_id || ""} onChange={handleInputChange} />
                                                </div>
                                                {errors.wechat_id && <span className="error">{errors.wechat_id}</span>}
                                                <div className="form-item">
                                                    <label className="form-label">{t("personal_info.wechat")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="wechat_name" value={formData.wechat_name || ""} placeholder="" onChange={handleInputChange} />
                                                </div>
                                                {errors.wechat_name && <span className="error">{errors.wechat_name}</span>}
                                                <div className="form-item">
                                                    <label for="wechat_image" className="form-label">
                                                        {t("registration.wechatImage")}
                                                        <span style={{ "color": "#ff0000" }}>*</span>
                                                    </label>
                                                    {previews.wechat_image && (
                                                        <img src={previews.wechat_image} className="img-thumbnail mt-3" style={{ maxWidth: "200px" }} />
                                                    )}
                                                    <input
                                                        type="file"
                                                        className="form-control mt-2"
                                                        onChange={handleFileChange}
                                                        id="wechat_image"
                                                    />
                                                </div>
                                                <div className="form-info mt-2">
                                                    <p className='mb-0'>{t("general.smallerFile10MB")}</p>
                                                </div>
                                                {fileError?.wechat_image && <span className="error">{fileError?.wechat_image}</span>}
                                                {errors.wechat_image && <span className="error">{errors.wechat_image}</span>}
                                                <div className='section-title mb-2 mt-4'>
                                                    <p className='m-0'>
                                                        <strong>{t("registration.addWechatTitle")}</strong>
                                                        <br /><br />
                                                        {t("registration.addWechat")}
                                                        <br />
                                                        <img src="/retreat-my/images/wechatqr.jpg" style={{ "width": "250px" }} alt="" />
                                                    </p>
                                                </div>
                                            </>
                                        }
                                        {
                                            formData.preferred_social_media === "Line" &&
                                            <>
                                                <div className="form-item">
                                                    <label className="form-label">{t("personal_info.line")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <input type="text" className="form-control" id="line_id" value={formData.line_id || ""} onChange={handleInputChange} />
                                                </div>
                                                {errors.line_id && <span className="error">{errors.line_id}</span>}
                                                <div className="form-item">
                                                    <label for="line_image" className="form-label">
                                                        {t("registration.lineImage")}
                                                        <span style={{ "color": "#ff0000" }}>*</span>
                                                    </label>
                                                    {previews.line_image && (
                                                        <img src={previews.line_image} className="img-thumbnail mt-3" style={{ maxWidth: "200px" }} />
                                                    )}
                                                    <input
                                                        type="file"
                                                        className="form-control mt-2"
                                                        onChange={handleFileChange}
                                                        id="line_image"
                                                        name={formData?.line_image?.name || ""}
                                                    />
                                                </div>
                                                <div className="form-info mt-2">
                                                    <p className='mb-0'>{t("general.smallerFile10MB")}</p>
                                                </div>
                                                {fileError?.line_image && <span className="error">{fileError?.line_image}</span>}
                                                {errors.line_image && <span className="error">{errors.line_image}</span>}
                                                <div className='section-title mb-2 mt-4'>
                                                    <p className='m-0'>
                                                        <strong>{t('registration.addLine')}</strong>
                                                        <br />
                                                        Line ID：godhamma
                                                    </p>
                                                </div>
                                            </>
                                        }
                                        {
                                            formData?.participation_type === "In-person" &&
                                            <>
                                                <div className="form-item">
                                                    <label for="personal_photo" className="form-label">
                                                        {t("registration.personalPhoto")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    {previews.personal_photo && (
                                                        <img src={previews.personal_photo} className="img-thumbnail mt-3" style={{ maxWidth: "200px" }} />
                                                    )}
                                                    <input
                                                        type="file"
                                                        className="form-control mt-2"
                                                        onChange={handleFileChange}
                                                        id="personal_photo"
                                                    />
                                                </div>
                                                {fileError?.personal_photo && <span className="error">{fileError?.personal_photo}</span>}
                                                {errors.personal_photo && <span className="error">{errors.personal_photo}</span>}
                                                <div className="form-info mt-2">
                                                    <p className='mb-0'>
                                                        <Trans html="br/:<br />">
                                                            {t("registration.personalPhotoFormInfo")}
                                                        </Trans>
                                                    </p>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className='form-section-6' hidden={formSection !== 6}>
                                        <h3>{t("registration.languageOption")}</h3>
                                        <h5>{t("registration.languageOptionLabel")}</h5>
                                        <div className="form-item">
                                            <label for='retreat_language'>{t("registration.duringCourse")}
                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                            <select className="form-select" id='retreat_language' onChange={handleInputChange} value={formData?.retreat_language || ""}>
                                                <option value="" hidden></option>
                                                <option value="Chinese">{t("registration.chinese")}</option>
                                                <option value="English">{t("registration.english")}</option>
                                                <option value="Thai">{t("registration.thai")}</option>
                                            </select>
                                            <div className="form-info">
                                                <p className='m-0'>{t("registration.duringCourseDesription")}</p>
                                            </div>
                                        </div>
                                        {errors.retreat_language && <span className="error">{errors.retreat_language}</span>}
                                        {
                                            formData?.participation_type === "In-person" &&
                                            <>
                                                <div className="form-item">
                                                    <label for='interview_language'>{t("registration.duringInterview")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <select className="form-select" id='interview_language' onChange={handleInputChange} value={formData?.interview_language || ""}>
                                                        <option value="" hidden></option>
                                                        <option value="Chinese">{t("registration.chinese")}</option>
                                                        <option value="English">{t("registration.english")}</option>
                                                        {/* <option value="thai">{t("registration.thai")}</option> */}
                                                    </select>
                                                    <div className="form-info">
                                                        <p className='m-0'>{t("registration.duringInterviewDesription")}</p>
                                                    </div>
                                                </div>
                                                {errors.interview_language && <span className="error">{errors.interview_language}</span>}
                                            </>
                                        }

                                        {/* <div className="form-item">
                                        <label for='pre_retreat_language'>{t("registration.duringPreretreat")}
                                            <span style={{ "color": "#ff0000" }}>*</span></label>
                                        <select className="form-select" id='pre_retreat_language' onChange={handleInputChange}>
                                            <option value="" hidden></option>
                                            <option value="Chinese">{t("registration.chinese")}</option>
                                            <option value="English">{t("registration.english")}</option>
                                            <option value="Thai">{t("registration.thai")}</option>
                                        </select>
                                        <div className="form-info">
                                            <p className='m-0'>{t("registration.duringPreretreatDesription")}</p>
                                        </div>
                                    </div> */}
                                    </div>
                                    <div className='form-section-7' hidden={formSection !== 7}>
                                        <div className='section-title mb-2'>
                                            <h4 className='mb-0'>{t("registration.submissionTitle")}</h4>
                                        </div>
                                        <div className='pt-2 pb-3'>
                                            <p className='mt-2'>
                                                {t("registration.registerImportant1")}
                                                <span style={{ "color": "#ff0000" }}>{t("registration.registerImportant1_2")}</span>
                                                {t("registration.registerImportant1_3")}
                                                &nbsp;
                                                <Link to={`${base_url}/search_eligibility`} target="_blank" rel="noopener noreferrer">
                                                    https://www.shineling.org/retreat-my/search_eligibility
                                                </Link>
                                                <br /><br />
                                                {t("registration.submissionDesription")}
                                            </p>
                                            <p className='mt-5'>
                                                <strong>{t("registration.organizer")}</strong>
                                                <Trans html="br:<br/>">
                                                    {t("registration.organizerDescription")}
                                                </Trans>
                                            </p>
                                            <p className='mt-5'>
                                                <strong>{t("general.contact_Info")}</strong>
                                                <Trans key="general" html="br:<br/>">
                                                    {t("general.infoContent")}
                                                    <a href="mailto:retreat@shineling.org">{t("general.retreatEmail")}</a>
                                                </Trans>
                                                {/* <br />
                                                <Link to="https://www.shineling.org:3004" target="_blank" rel="noopener noreferrer">
                                                    {t("general.retreatChatbot")}
                                                </Link> */}
                                                <br />{t("general.retreatWhatsapp")}+6018-919 9096
                                                <br />{t("general.retreatWechat")}godhamma
                                            </p>
                                            <p>
                                                -----------------------------
                                                <Trans key="general" html="br/:<br />">
                                                    <br />{t("general.snl")}
                                                </Trans>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='button-container mt-3'>
                                        <Button buttonStyle="btn--primary" hidden={formSection === 1} disabled={isSubmitting} type="button" onClick={() => navigateFormSection(false)}>{t("general.BTNprevious")}</Button>
                                        <Button buttonStyle="btn--primary" hidden={formSection === 7} type="button" onClick={() => navigateFormSection(true)}
                                            disabled={!isPledge && formSection == 2}>{t("general.BTNnext")}</Button>
                                        <Button buttonStyle="btn--primary" hidden={formSection !== 7} onClick={handleSubmit} type="button">
                                            {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </>
            }
        </>
    )
}

export default CourseRegistration